import { DISPLAY_TWEAK_DEFS, resetDisplayTweaks, useTweakValues } from '@/lib/tweak-store';
import { type EnumDef, SETTING_SECTIONS } from '@mss_creator/shared';
import { Button, Icon } from '@pms-digital/design-system';
import { SettingSection } from './setting-section';
import { TweakTileRow } from './tweak-tile-row';

const DISPLAY_SECTIONS = SETTING_SECTIONS.filter((section) => section.id !== 'systeme');

function isEnumDef(def: (typeof DISPLAY_TWEAK_DEFS)[number]): def is EnumDef {
  return def.type === 'enum';
}

/**
 * The "Affichage" tab: the six visual tweaks, grouped by the screen they
 * affect, each as a row of option tiles with a live miniature. Everything here
 * is per browser (localStorage); the footer resets these six and leaves the
 * simulated role alone.
 */
export function DisplayTab() {
  const tweaks = useTweakValues();
  const anyModified = DISPLAY_TWEAK_DEFS.some((def) => tweaks[def.key] !== String(def.default));

  return (
    <div>
      <p className="mb-2 flex items-center gap-2 font-light text-gray-700 text-small">
        <Icon name="desktop_windows" size={16} />
        Ces réglages ne concernent que ce navigateur : vos collègues ne voient pas vos choix.
      </p>
      {DISPLAY_SECTIONS.map((section) => (
        <SettingSection key={section.id} title={section.title} where={section.where}>
          {DISPLAY_TWEAK_DEFS.filter(isEnumDef)
            .filter((def) => def.section === section.id)
            .map((def) => (
              <TweakTileRow key={def.key} def={def} tweaks={tweaks} />
            ))}
        </SettingSection>
      ))}
      <div className="mt-2 flex flex-wrap items-center gap-4 border-gray-200 border-t pt-6">
        <Button variant="primary" size="sm" disabled={!anyModified} onClick={resetDisplayTweaks}>
          Réinitialiser l'affichage
        </Button>
        <p className="font-light text-gray-600 text-small">
          Remet les 6 réglages ci-dessus à leur valeur par défaut. Le rôle simulé n'est pas
          concerné.
        </p>
      </div>
    </div>
  );
}
